import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../common/components/table";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../components/PageLoader";
import { selectCrmcontactsListItems } from "../../../../../redux/crm-contacts/selector";
import { crmcontacts } from "../../../../../redux/crm-contacts/action";


const Oneusercontacts = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const itemsData = useSelector(selectCrmcontactsListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'FirstName', headerName: 'First Name' , searchField: 'FirstName', filter: true},
      { field: 'LastName', headerName: 'Last Name' , searchField: 'LastName', filter: true},
      { field: 'Phone', headerName: 'Phone' ,searchField: 'Phone', filter: true },
      { field: 'Email', headerName: 'Email' , searchField: 'Email', filter: true}
    ]);
  }
  const handleSearch = (data: any) => {
    console.log('Search data', data)
    let searchCriteria = {};
    if (data?.column){
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }

    dispatch(crmcontacts.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/contacts/list`,
      entity: 'contacts',
      jsonData: { "PageNumber": pageData,
      "PageSize": 10,
      "SortField": "Id",
      "SortOrder": "desc",
      "Searches": searchCriteria,}
  }));
  }
  const filterTypes = [{
    name: 'Text', value: "text"
  },
  {
    name: 'Number', value: "number"
  },
  {
    name: 'CheckBox', value: "checkbox"
  },
  {
    name: 'Date', value: "date"
  }
  ]
  const handleReloadData = () => {
    fetchContactsList();
  }
  
  const handleAdd = () => {
    navigate(`${0}`)
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }

  const handleDelete = (data: any) => {
    dispatch(crmcontacts.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/contacts/delete`,
      entity: 'contacts',
      jsonData: {
        Records: [
          {
            Id: data?.Id
          }
        ]
      }
    })).then(() => {
      dispatch(crmcontacts.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/contacts/list`,
        entity: 'contacts',
        jsonData: {
          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }));
    });
  }

  const additionButtons: any = [
    {
      name: 'Add Contacts',
      callback: () => handleAdd(),
    },
    {
      svg:
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
        <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>,
      name: 'Reload',
      callback: () => handleReloadData(),
    },
  ];

  const fetchContactsList = () => {
    dispatch(crmcontacts.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/contacts/list`,
      entity: 'contacts',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }
  useEffect(() => {
    createColumnDefs()
    fetchContactsList()
  }, [pageData])

  return (
    <>
      {itemsData?.isLoading ? <PageLoader /> :
        <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData}
          paginationData={itemsData?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete}
          additionButtons={additionButtons} headingName="Contacts"  filterTypeLists={filterTypes}  onSearch={handleSearch}
          enableFilter={true}/>
      }
    </>
  );
};

export default Oneusercontacts;





